export default __webpack_public_path__ + "static/media/ALK_0.1b8603f5.jpg";